// Ekran 09 — Stok Hareketleri API istemcisi.

import { api } from '../../lib/api'

export type BelgeTipi = 'LOT' | 'BSL' | 'SVK' | 'DLM' | 'STN' | 'SRF' | 'SAY' | 'STORNO'

/** Ekran 09 tür segmenti — "Sarf & Yedek" iki stok türünü birlikte kapsar. */
export type HareketTuru = 'tumu' | 'ham' | 'urun' | 'sarf' | 'yakit'

/** Ekran 09 yön segmenti: giriş · çıkış · düzeltme/storno. */
export type HareketYonu = 'tumu' | 'g' | 'c' | 'd'

export type HareketSatiri = {
  id: string
  zaman: string
  belgeNo: string
  belgeTip: BelgeTipi
  /** Belgenin altındaki gri satır — "Mal kabul · onaylı". */
  kaynak: string
  tur: HareketTuru
  stokKod: string
  stokAd: string
  havuz: string | null
  yon: number
  miktar: number
  birim: string
  birimDeger: number | null
  bakiyeSonrasi: number | null
  stornoEdildi: boolean
  gerekce: string | null
}

export type LotZinciri = {
  plaka: string | null
  surucu: string | null
  seferEtiketi: string | null
  numuneEtiketi: string | null
  haoOncesi: number | null
  haoSonrasi: number | null
}

export type BeslemeBilgisi = {
  kalemler: { etiket: string; miktar: number; birim: string }[]
  stokCikisi: number
  beyanToplami: number | null
  farkYuzde: number | null
  /** K9 toleransı (`ayar_esik.besleme_tolerans`) — bant metni buradan yazılır. */
  tolerans: number | null
  /** K19: hijyen bayraklı kart beslendiyse günün parti özeti; yoksa null. */
  hijyen: string | null
}

/** SVK satırının araç / irsaliye / alıcı listesi (K14); kaynağı olmayan alan null. */
export type SevkBilgisi = {
  arac: string | null
  irsaliye: string | null
  alici: string | null
}

export type StornoBilgisi = {
  orijinalBelgeNo: string
  orijinalHareketId: string | null
  tersBelgeNo: string | null
  tersHareketId: string | null
  gerekce: string | null
}

export type HareketDetayi = {
  satir: HareketSatiri
  lot: LotZinciri | null
  besleme: BeslemeBilgisi | null
  sevk: SevkBilgisi | null
  storno: StornoBilgisi | null
  not: string | null
  kaynakModul: string | null
  kaynakRefId: string | null
  stornoEdilebilir: boolean
}

export type HareketOzeti = {
  bugunGirisTon: number
  bugunGirisLot: number
  bugunCikisTon: number
  hammaddeStoku: number
  hammaddeHavuzSayisi: number
  urunStokuKati: number | null
  urunStokuSivi: number | null
  beslemeMutabakatiYuzde: number | null
}

export type ManuelHareketIstek = {
  yon: number
  stokKartiId: string
  firmaUrunHavuzuId?: string | null
  miktar: number
  birim?: string | null
  gerekce: string
}

export const hareketler = {
  liste: (s: { tur?: HareketTuru; yon?: HareketYonu; q?: string; tarih?: string } = {}) => {
    const p = new URLSearchParams()
    if (s.tur && s.tur !== 'tumu') p.set('tur', s.tur)
    if (s.yon && s.yon !== 'tumu') p.set('yon', s.yon)
    if (s.q) p.set('q', s.q)
    if (s.tarih) p.set('tarih', s.tarih)
    const qs = p.toString()
    return api<HareketSatiri[]>(`/api/hareketler${qs ? `?${qs}` : ''}`)
  },

  ozet: () => api<HareketOzeti>('/api/hareketler/ozet'),

  detay: (id: string) => api<HareketDetayi>(`/api/hareketler/${id}`),

  manuel: (govde: ManuelHareketIstek) =>
    api<{ satir: HareketSatiri; mesaj: string }>('/api/hareketler', {
      yontem: 'POST',
      govde,
    }),

  storno: (id: string, gerekce: string) =>
    api<{
      tersHareketId: string
      tersBelgeNo: string
      bakiyeSonrasi: number | null
      mesaj: string
    }>(`/api/hareketler/${id}/storno`, { yontem: 'POST', govde: { gerekce } }),
}
